import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css';

/* Router Dom */
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';

import { createBrowserHistory } from "history";



import Home from './pages/Home';
import LoneSmart from './pages/LoneSmart';
import SubWAVE from './pages/SubWAVE';
import UAM from './pages/UAM';
import UAMSimulatorKorean from './pages/UAMSimulatorKorean';
import Contact from './pages/Contact';

/* Board */
import Board from './pages/board/Board';
import BoardWrite from './pages/board/BoardWrite';
import BoardUpdate from './pages/board/BoardUpdate';
import BoardView from './pages/board/BoardView';
/* Notice */
import Notice from './pages/notice/Notice';
import NoticeWrite from './pages/notice/NoticeWrite';
import NoticeUpdate from './pages/notice/NoticeUpdate';
import NoticeView from './pages/notice/NoticeView';
/* Login */
import Login from './pages/login/Login';
import Register from './pages/login/Register';
import Profile from './pages/login/Profile';
/* Admin */
import UserList from './pages/admin/UserList';
import UserUpdate from './pages/admin/UserUpdate';
import ContactList from './pages/admin/ContactList';
import ContactView from './pages/admin/ContactView';
import ServerState from './pages/admin/ServerState';
import Setting from './pages/admin/Setting';

import Privacy from './pages/layouts/Privacy';
import Prohibited from './pages/layouts/Prohibited';


import 'normalize.css'

import './locales/i18n'; // Ensure i18n.js is imported before your app starts

const hist = createBrowserHistory();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router history={hist}>
    <div className="App">
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/Home/:param" element={<Home />} />
          <Route path="/LoneSmart" element={<LoneSmart />} />
          <Route path="/LoneSmart/:param" element={<LoneSmart />} />
          <Route path="/SubWAVE" element={<SubWAVE />} />
          <Route path="/SubWAVE/:param" element={<SubWAVE />} />
          <Route path="/UAM" element={<UAMSimulatorKorean />} />
          <Route path="/UAM/:param" element={<UAMSimulatorKorean />} />
          <Route path="/UAMLegacy" element={<UAM />} />
          <Route path="/UAMLegacy/:param" element={<UAM />} />
          <Route path="/Contact" element={<Contact />} />
          {/* Board */}
          <Route path="/Board" element={<Board />} />
          <Route path="/BoardWrite" element={<BoardWrite />} />
          <Route path="/BoardUpdate/:param" element={<BoardUpdate />} />
          <Route path="/BoardView/:param" element={<BoardView />} />
          {/* Notice */}
          <Route path="/Notice" element={<Notice />} />
          <Route path="/NoticeWrite" element={<NoticeWrite />} />
          <Route path="/NoticeUpdate/:param" element={<NoticeUpdate />} />
          <Route path="/NoticeView/:param" element={<NoticeView />} />
          {/* Login */}
          <Route path="/Login" element={<Login />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/Profile" element={<Profile />} />
          {/* Admin */}
          <Route path="/UserList" element={<UserList />} />
          <Route path="/UserUpdate/:param" element={<UserUpdate />} />
          <Route path="/ContactList" element={<ContactList />} />
          <Route path="/ContactView/:param" element={<ContactView />} />
          <Route path="/ServerState" element={<ServerState/>} />
          <Route path="/Setting" element={<Setting/>} />

          <Route path="/Privacy" element={<Privacy />} />
          <Route path="/Prohibited" element={<Prohibited />} />
      </Routes>
    </div>
  </Router>
);